import { env } from '../env'
 
// const baseURL = env_set == 3 ? process.env.REACT_APP_BACKEND_URL : env_set == 2 ? process.env.REACT_APP_BACKEND_URL_BETA : process.env.REACT_APP_BACKEND_URL_PROD;

// const selfcareURL = env_set == 3 ? process.env.REACT_APP_SELFCARE_URL : env_set == 2 ? process.env.REACT_APP_SELFCARE_URL_BETA : process.env.REACT_APP_SELFCARE_URL_PROD;
export const baseURL = env.REACT_APP_BACKEND_URL

const selfcareURL = env.REACT_APP_SELFCARE_URL

export const TTTC_PATH = env.REACT_APP_TTTC_PATH
export const CTKM_NEWS_ID = env.REACT_APP_CTKM_NEWS_ID
export const CTKM_CAT_ID = env.REACT_APP_CTKM_CAT_ID
export const CTKM_CASHBACK_50_NEWS_ID = env.REACT_APP_CTKM_CASHBACK_50_NEWS_ID
export const CTKM_CASHBACK_50_CAT_ID = env.REACT_APP_CTKM_CASHBACK_50_CAT_ID
export const MAX_COUNT_CHECK_TRANS_STATUS_QR_CODE_MYVNPT = env.REACT_APP_MAX_COUNT_CHECK_TRANS_STATUS_QR_CODE_MYVNPT
export const TIMER_CHECK_TRANS_STATUS_QR_CODE_MYVNPT = env.REACT_APP_TIMER_CHECK_TRANS_STATUS_QR_CODE_MYVNPT

export const QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST = env.REACT_APP_QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST
export const QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL = env.REACT_APP_QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL
export const DETECT_DEEPLINK_PACKAGE_LIST_ENDPOINT = env.REACT_APP_DETECT_DEEPLINK_PACKAGE_LIST_ENDPOINT;
export const DETECT_PACKAGE_LIST_MILLISECOND = env.REACT_APP_DETECT_PACKAGE_LIST_MILLISECOND;

export const GTM_ID_ROAMING = env.REACT_APP_GTM_ID_ROAMING

export const env_set = baseURL.includes("my.vnpt.com.vn") == true ? 1 : baseURL.includes("beta.myvnpt.com.vn") == true ? 2 : 3 // 1: production, 2: beta, 3: staging

export const BACKEND_API = `${baseURL}/mapi/services`;
export const BACKEND_API_CONFIG_SERVICE = `${baseURL}/config_service`;
export const BACKEND_API_VPLUS = `${baseURL}/vplus_service/vinaphone_plus/forWeb`;
export const BACKEND_API_LOYALTY = `${baseURL}/vplus_service/loyalty`;
export const PAY_MONEY_API = `${baseURL}/VNPTPay/topup_2.0.0.jsp?sandbox=release`;
export const PAY_BILL_API = `${baseURL}/VNPTPay/pay_1.0.6.jsp?sandbox=release`;
export const PAY_API = `${baseURL}/pay`;
export const BACKEND_API_QR_CODE_MYVNPT = `${baseURL}/package_service/web/payment`;
export const BACKEND_API_BANNER = `${baseURL}/config_service/banner`;

export const SELFCARE = `${selfcareURL}`;
// export const SELFCARE = `${baseURL}/doanh-nghiep`;

export const URL_LOGIN_3G = 'http://auth-myvnpt.vnpt.vn';
export const YOUR_API_KEY = 'AIzaSyDnXwhhg8SfyNqOzPcFJvW3NywvXoRPRww';

//pay
// const payURL = 'https://sandboxpay.vnptmedia.vn/webview-portal'; //sandbox
// const payURL = 'https://congdichvulive2.vnptmoney.vn'; //live2
const payURL = 'https://congdichvu.vnptmoney.vn'; //live
export const PAY_PORTAL = `${payURL}/services/`

// key_landing_page
// token = SHA256(msisdn+"|"+request_id+"|"+partner_code+"|"+SECRET_KEY)
export const  SECRET_KEY = "6633e56f055a80a94ca621797874c137";

export const URL_VNPTPAY = "https://vnptpay.vn/bill"
export const SECRET_KEY_MYVNPT_VINAPHONE_PLUS_FOR_WEB = env.REACT_APP_SECRET_KEY_MYVNPT_VINAPHONE_PLUS_FOR_WEB
export const TTTC_PARAM = env.REACT_APP_TTTC_PARAM
export const LIST_EXCLUDED_PATHS = env.REACT_APP_LIST_EXCLUDED_PATHS
export const LIVE_BOT_URL = env.REACT_APP_LIVE_BOT_URL
